export interface ISelectable {
  isSelected: boolean;
}

export interface ISelectionList {
  list: ISelectable[];
  maximum: number;
}

export class SelectionListServant {
  build(): ISelectionList {
    return {
      list: [],
      maximum: 0
    };
  }
  setMaximum(selectionList: ISelectionList, maximum: number): ISelectionList {
    selectionList.maximum = maximum;
    return selectionList;
  }
  isFull(selectionList: ISelectionList): boolean {
    return selectionList.list.length >= selectionList.maximum;
  }
  isEmpty(selectionList: ISelectionList): boolean {
    return selectionList.list.length === 0;
  }
  reset(selectionList: ISelectionList): ISelectionList {
    selectionList.list = [];
    return selectionList;
  }
  selectAll(selectionList: ISelectionList, items: ISelectable[]): ISelectionList {
    _.each(items, (item: ISelectable): ISelectionList => this.select(selectionList, item));
    return selectionList;
  }
  select(selectionList: ISelectionList, item: ISelectable, searchKey: string = 'isSelected'): ISelectionList {
    if (selectionList.list.length < selectionList.maximum && !this._isAlreadySelected(selectionList, item)) {
      _.set(item, searchKey, true);
      selectionList.list.push(item);
    }
    return selectionList;
  }
  private _isAlreadySelected(selectionList: ISelectionList, item: ISelectable): boolean {
    return _.contains(selectionList.list, item);
  }
  unselectAll(selectionList: ISelectionList, searchKey?: string) {
    _.each(selectionList.list, (item) => {
      this.unselect(selectionList, item, searchKey);
    });
    return selectionList;
  }
  unselect(selectionList: ISelectionList, item: ISelectable, searchKey: string = 'isSelected'): ISelectionList {
    _.set(item, searchKey, false);
    _.remove(selectionList.list, item);
    return selectionList;
  }
  replaceSelect(selectionList: ISelectionList, item: ISelectable): ISelectionList {
    this.unselectAll(selectionList);
    return this.select(selectionList, item);
  }
  toString(selectionList: ISelectionList): string {
    return `${selectionList.list.length} of ${selectionList.maximum}`;
  }
}

angular.module('capability-ng-global').service('ngSelectionListServant', SelectionListServant);



// WEBPACK FOOTER //
// ./app/lib/global/servants/selection_list_servant.ts